import { useTranslator } from '@translator-app/react';
import React from 'react';

import { Heading } from '../atoms/heading';
import { Link } from '../atoms/link';

export interface NotFoundProps {}

export function NotFound() {
  let { translate } = useTranslator();

  return (
    <div className="mx-auto max-w-7xl px-6 py-8">
      <Heading>{translate('errorScreen.notFoundTitle')}</Heading>
      <div>{translate('errorScreen.notFoundDescription')}</div>
      <div className="my-4">
        <Link href="/">{translate('errorScreen.seeAllShops')}</Link>
      </div>
    </div>
  );
}
